export type AdminStaffRole = "admin" | "viewer_pii" | "viewer_no_pii";

export type AdminWhoami = {
	email: string | null;
	role: AdminStaffRole;
	userId: string;
};

export const ROLE_LABEL: Record<AdminStaffRole, string> = {
	admin: "管理者",
	viewer_pii: "閲覧者（個人情報許可）",
	viewer_no_pii: "閲覧者（個人情報不許可）",
};
